import {VerificationStatus} from "src/integrations/identityVerification/constants";
import {IdentityVerification} from "src/integrations/identityVerification/factory";
import React from "react";
import styled from "styled-components";
import {CheckmarkDone} from "@styled-icons/ionicons-sharp";
import {Warning} from "@styled-icons/fluentui-system-regular";
import {AccessTime} from "@styled-icons/material";
import {Close} from "@styled-icons/ionicons-outline";

const DocumentsIdentityVerificationLabel = ({verificationData, deliveryType}) => {
  const {status, idVerificationService} = verificationData;
  const isVerified = verificationData.idVerification.isVerified(deliveryType.code);
  const isVerifiedBy = verificationData.isVerifiedBy;

  if (
    status === VerificationStatus.WAITING &&
    idVerificationService === IdentityVerification.BERBIX
  ) {
    return (
      <IdVerificationContainer backgroundColor={VERIFICATION_STATUS_COLOR[status]}>
        <WarningIcon />
        <span style={{fontSize: "11px"}}>Verification incomplete!</span>
      </IdVerificationContainer>
    );
  }

  if (
    status === VerificationStatus.REVIEW &&
    idVerificationService === IdentityVerification.BERBIX
  ) {
    return (
      <IdVerificationContainer backgroundColor={VERIFICATION_STATUS_COLOR[status]}>
        <AccessTimeIcon />
        <span>
          Under <Service>{idVerificationService}</Service> review
        </span>
      </IdVerificationContainer>
    );
  }

  if (
    status === VerificationStatus.REJECTED &&
    idVerificationService === IdentityVerification.BERBIX
  ) {
    return (
      <IdVerificationContainer backgroundColor={VERIFICATION_STATUS_COLOR[status]}>
        <CloseIcon />
        <span>Rejected</span>
      </IdVerificationContainer>
    );
  }

  if (isVerified && isVerifiedBy === IdentityVerification.BERBIX) {
    return (
      <IdVerificationContainer backgroundColor={VERIFICATION_STATUS_COLOR[status]}>
        <CheckmarkDoneIcon />
        <span>
          Verified by <Service>{isVerifiedBy}</Service>
        </span>
      </IdVerificationContainer>
    );
  }

  if (idVerificationService === IdentityVerification.BERBIX && status) {
    return (
      <IdVerificationContainer backgroundColor={VERIFICATION_STATUS_COLOR.default}>
        <AccessTimeIcon />
        <span>{status}</span>
      </IdVerificationContainer>
    );
  }

  return <IdVerificationContainer />;
};

const IdVerificationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  background-color: ${({backgroundColor}) => backgroundColor};
  color: white;
  height: 26px;
  font-size: 12px;
`;
const CheckmarkDoneIcon = styled(CheckmarkDone)`
  width: 20px;
`;
const WarningIcon = styled(Warning)`
  width: 20px;
`;
const AccessTimeIcon = styled(AccessTime)`
  width: 20px;
`;
const CloseIcon = styled(Close)`
  width: 20px;
`;
const Service = styled.span`
  text-transform: capitalize;
`;

const VERIFICATION_STATUS_COLOR = {
  accepted: "#5FC090",
  rejected: "#BA0B15",
  waiting: "#F2994A",
  review: "#F2994A",
  default: "#888888",
};

export default DocumentsIdentityVerificationLabel;
